module.exports = __webpack_public_path__ + "img/chips200000.445c8848.webp";